// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"GlobalFilter_searchInputWrapper__0uVPI","searchInput":"GlobalFilter_searchInput__FXJ0B"};